/**
 * Created by liyihui on 2022/11/22.
 * 非接口请求字典
 */

//  import axios from 'axios';

const tenant = process.env.PROJECT_TYPE; // 租户
const platform = 'OFFICAL_WEBSITE'; // 平台

var copyrightText = ''; // 界面底部版权信息
if (tenant === 'SICHUAN') {
	copyrightText = '版权所有 未经许可 请勿转载 CopyRight 2017-2023 四川中油九洲北斗科技能源有限公司  蜀ICP备17039646号 版本V';

} else if (tenant === 'SHAANXI') {
	copyrightText = '授权使用：中油北斗(陕西)科技能源有限公司  备案号：蜀ICP备17039646号-2 增值电信业务许可证编号：川B2-20190490  客服电话：0816- 4006820016 客服邮箱：kefu@zyjzbd.com 版本V';

} else if (tenant === 'NINGXIA') {
	copyrightText = '授权使用：中油北斗（宁夏）科技能源有限公司  备案号：宁ICP备18001225号  客服电话：4008165665  客服邮箱:kefu@nxzybd.com 版本V';
	
} else {
	copyrightText = '平台配置发生错误';
}

// 普通字段
var staticField = {
	orderProgressRunning: [
		{ value: 'BLOCKED', label: '处理中', },
		{ value: 'LOCKED', label: '已上锁', },
		{ value: 'READY', label: '创建中', },
	],
	orderProgressClosed: [
		{ value: 'CANCELED', label: '已取消', },
		{ value: 'DONE', label: '已完成', },
	],

	chargeOrderState: [
		{ value: 'F030_N010', label: '订单提交中', },
		{ value: 'F030_N020', label: '是否贷款', },
		{ value: 'F030_N030', label: '贷款处理', },
		{ value: 'F030_N040', label: '到账审核', },
		{ value: 'F030_N050', label: '财务审核', },
		{ value: 'F030_N060', label: '运营审核', },
		{ value: 'F030_N070', label: '挂起', },
		{ value: 'F030_N980', label: '驳回', },
		{ value: 'F030_N990', label: '完成', },
	],
}
// 生成一下订单进程的完整状态数组
staticField.orderProgressTotal = [ ...staticField.orderProgressRunning, ...staticField.orderProgressClosed, ];

// 接口白名单
export const whiteList = [	'sendSmsCode', 'managementLogin', ];

const dictionary = {
	tenant,
	platform,
	copyrightText,

	staticField,
}

export default dictionary;



// WEBPACK FOOTER //
// ./src/utils/dictionary.js